import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  Validators,
} from "@angular/forms";
import moment from 'moment';
import { ActivatedRoute } from "@angular/router";
import {MatDialog} from '@angular/material/dialog';
import { CurrencyPipe } from "@angular/common";

import { ApiCallService } from "../../../api/service/api-call.service";
import { ValidationService } from "src/app/services/validation.service";
import { ConfirmComponent } from "src/app/components/dialog/confirm/confirm.component";
import { IConfirmDialogData } from "src/app/components/dialog/dialog.data";
import * as Constants from "../../../constant/Constants";
import { English, Kiswahili } from 'src/app/assets/strings/TZ/localization';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-benefits',
  templateUrl: './benefits.component.html',
  styleUrls: ['./benefits.component.css']
})
export class BenefitsComponent implements OnInit {

  // Url Params
  journey: string = "new"; // new, existing ... etc.
  insurance: string = "private"; // private, commercial, special, motorcycle ... etc.
  locale: string = "en";  // en || sw (Language)
  token: string = "placeholder-value"; // to validate the public accesses.
  // +++++++++++

  genericDialogData: IConfirmDialogData = {
    title: '',
    content: '',
    cancelButtonText: '',
    confirmButtonText: ''
  };

  LanguagePack: any = English;

  pageHeading: string = 'Motor Insurance Application';

  minCoverDate: Date = new Date();
  maxCoverDate: Date = new Date(new Date().getFullYear() + 1, new Date().getMonth(), new Date().getDate());

  formErrors: { [key: string]: string } = {
    windscreenAmount: "",
    entertainmentAmount: "",
    coverStartDate: "",
  };

  validationMessages: { [key: string]: {} } = {
    windscreenAmount: { required: this.LanguagePack.requiredValidation, cMin: this.LanguagePack.minimumValidation + "TZS 1,000,000", cMax: this.LanguagePack.maximumValidation + "TZS 5,000,000" },
    entertainmentAmount: { required: this.LanguagePack.requiredValidation, cMin: this.LanguagePack.minimumValidation + "TZS 500,000", cMax: this.LanguagePack.maximumValidation + "TZS 1,000,000" },
    coverStartDate: { required: this.LanguagePack.coverStartDateValidation },
  };

  motorForm = this._formBuilder.group({
    excessProtector: false,
    politicalViolence: false,
    lossUse: false,

    windscreen: false,
    windscreenAmount: [""],

    entertainment: false,
    entertainmentAmount: [""],

    coverStartDate: [moment(null), Validators.required],
  });

  constructor(
    private _formBuilder: FormBuilder,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private apiCallService: ApiCallService,
    private validationService: ValidationService,
    private currencyPipe: CurrencyPipe,
  ) { }

  loading: boolean = false;
  url: string = environment.baseUrl + Constants.benefitsTZ_URL;

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.token = params["token"] !== 'undefined' ? params["token"] : Constants.tokenPlaceholderValue;

      if (params["locale"] !== undefined) {
        this.locale = params["locale"];
        // Change to Swahili language
        if (params["locale"] === "sw") {
          this.LanguagePack = Kiswahili;
          this.validationMessages = {
            windscreenAmount: { required: this.LanguagePack.requiredValidation, cMin: this.LanguagePack.minimumValidation + "TZS 1,000,000", cMax: this.LanguagePack.maximumValidation + "TZS 5,000,000" },
            entertainmentAmount: { required: this.LanguagePack.requiredValidation, cMin: this.LanguagePack.minimumValidation + "TZS 500,000", cMax: this.LanguagePack.maximumValidation + "TZS 1,000,000" },
            coverStartDate: { required: this.LanguagePack.coverStartDateValidation },
          };
        }
      }

      if (params["journey"] !== undefined) {
        this.journey = params["journey"];
      }

      if (params["insurance"] !== undefined) {
        this.insurance = params["insurance"];
        this.pageHeading = this.LanguagePack.pagePrivate;

        // if (params["insurance"] === "commercial") {
        //   this.pageHeading = this.LanguagePack.pageCommercial;
        //   this.url = environment.baseUrl + Constants.benefitsTZ_URL;

        // } else if (params["insurance"] === "special") {
        //   this.pageHeading = this.LanguagePack.pageSpecial;
        //   this.url = environment.baseUrl + Constants.benefitsTZ_URL;

        // } else if (params["insurance"] === "motorcycle") {
        //   this.pageHeading = this.LanguagePack.pageMotorcycle;
        //   this.url = environment.baseUrl + Constants.benefitsTZ_URL;
        // }
      }
    });

    //logErrors on load
    this.motorForm.valueChanges.subscribe((form) => {
      this.logErrors();

      if (form.windscreenAmount) {
        this.motorForm.patchValue({
          windscreenAmount: this.currencyPipe.transform(form.windscreenAmount.replace(/\D/g, '').replace(/^0+/, ''), 'TZS  ', 'symbol', '1.0-0')
        }, {emitEvent: false});
      }
      if (form.entertainmentAmount) {
        this.motorForm.patchValue({
          entertainmentAmount: this.currencyPipe.transform(form.entertainmentAmount.replace(/\D/g, '').replace(/^0+/, ''), 'TZS  ', 'symbol', '1.0-0')
        }, {emitEvent: false});
      }
    });

    this.motorForm.get('windscreen')?.valueChanges.subscribe(value => {
      const windscreenAmount = this.motorForm.get('windscreenAmount')
      this.validationService.addTZCurrenciedValidator(value!,windscreenAmount!, 'win')
    });
    
    this.motorForm.get('entertainment')?.valueChanges.subscribe(value => {
      const entertainmentAmount = this.motorForm.get('entertainmentAmount')
      this.validationService.addTZCurrenciedValidator(value!,entertainmentAmount!, 'ent')
    });

  }

  logErrors() {
    this.formErrors = this.validationService.logValidationErrors(
      this.motorForm,
      this.formErrors,
      this.validationMessages
    );
  }

  clearWindscreenVal() {
    if (!this.motorForm.controls["windscreen"].value) {
      this.motorForm.controls["windscreenAmount"].setValue(null);
      this.motorForm.controls["windscreenAmount"].clearValidators();
    }
  }
  clearEntertainmentVal() {
    if (!this.motorForm.controls["entertainment"].value) {
      this.motorForm.controls["entertainmentAmount"].setValue(null);
      this.motorForm.controls["entertainmentAmount"].clearValidators();
    }
  }

  showGenericPopup(runFunction: ()=> void) {
    const dialogRef = this.dialog.open(ConfirmComponent, {
      disableClose: true,
      data: this.genericDialogData,
    });

    dialogRef.afterClosed().subscribe(result => {
      console.group('Generic Dialog');
      if (result) {
        console.log('dialog confirmed');
        runFunction();
      } else {
        console.log('dialog dismissed');
      }
      console.groupEnd();
    });
  };

  initDialogData(title: string, content: string, cancelButtonText: string, confirmButtonText: string) {
    this.genericDialogData.title = title;
    this.genericDialogData.content = content;
    this.genericDialogData.cancelButtonText = cancelButtonText;
    this.genericDialogData.confirmButtonText = confirmButtonText;
  };

  postDataToWhatsapp = async () => {
    this.loading = true;

    const req = {
      class: this.insurance,
      // Benefits
      windscreen:
        this.motorForm.controls["windscreen"].value ===
        true
          ? "Y"
          : "N",
      windscreenAmount:
        this.motorForm.controls["windscreen"].value ===
        true
          ? this.motorForm.controls["windscreenAmount"].value?.replace(/\D/g,'')
          : '1000000',

      entertainment:
        this.motorForm.controls["entertainment"].value ===
        true
          ? "Y"
          : "N",
      entertainmentAmount:
        this.motorForm.controls["entertainment"].value ===
        true
          ? this.motorForm.controls["entertainmentAmount"].value?.replace(/\D/g,'')
          : '500000',

      lossofUse:
        this.motorForm.controls["lossUse"].value === true
          ? "Y"
          : "N",
      excessprotector:
        this.motorForm.controls["excessProtector"]
          .value === true
          ? "Y"
          : "N",
      pvt:
        this.motorForm.controls["politicalViolence"]
          .value === true
          ? "Y"
          : "N",

      coverStartDate: this.motorForm.controls["coverStartDate"].value!.format("MM-DD-YYYY"),

      token: this.token,
      filled: true,
    };

    try {
      const response = await this.apiCallService.postRequest(`${this.url}?token=${this.token}`, req);

      console.log(":: Response data ::  ", response);

      if (response.error === false) {
        console.log("::: Post successful :::");
        // Auto-close the breakout page
        window.close();
      } else {
        console.log("::: Post failed :::", response.message);
        this.loading = false;

        this.initDialogData(
          this.LanguagePack.submissionFailed,
          this.LanguagePack.savingError,
          this.LanguagePack.cancel,
          this.LanguagePack.tryAgain
        );

        this.showGenericPopup(this.postDataToWhatsapp);
      }
    } catch (error) {
      console.log('ERROR :: ', error);
      this.loading = false;

      this.initDialogData(
        this.LanguagePack.submissionFailed,
        this.LanguagePack.unexpectedError,
        this.LanguagePack.cancel,
        this.LanguagePack.tryAgain
      );
      this.showGenericPopup(this.postDataToWhatsapp);
    }
    
  }

  submitForm(): void {
    this.initDialogData(
      this.LanguagePack.confirmSubmission,
      this.LanguagePack.proceedDesc,
      this.LanguagePack.back,
      this.LanguagePack.proceed
    );

    this.showGenericPopup(this.postDataToWhatsapp);
  }

  confirmCancel() {
    this.initDialogData(
      this.LanguagePack.warning,
      this.LanguagePack.confirmCancel,
      this.LanguagePack.backSmallCaps,
      this.LanguagePack.cancelApplication
    );

    this.showGenericPopup(this.cancelApplication);
  }
  
  cancelApplication = async () =>  {
    console.log("Cancelling application ...");
    // Update session that form application was cancelled
    this.loading = true;

    const req = {
      // User cancelled
      token: this.token,
      filled: false,
    };

    try {
      const response = await this.apiCallService.postRequest(`${this.url}?token=${this.token}`, req);

      console.log(":: Response data ::  ", response);

      if (response.error === false) {
        console.log("::: Cancel Post successful :::");
        // Auto-close the breakout page
        window.close();

      } else {
        console.log("::: Cancel Post failed :::", response.message);
        this.loading = false;

        this.initDialogData(
          this.LanguagePack.submissionFailed,
          this.LanguagePack.savingError,
          this.LanguagePack.cancel,
          this.LanguagePack.tryAgain
        );

        this.showGenericPopup(this.cancelApplication);
      }
    } catch (error) {
      console.log('ERROR :: ', error);
      this.loading = false;

      // Auto-close the breakout page
      window.close();
    }
  }

}
